import { Fire } from "./Fire";
import { fireMapping } from "../data/fireRatingMap";
import { FLAVORS } from "../flavor.constants";

type FlavorType = {
    color: string
    scale: number
}

export const FireRating = ({ sauce }: { sauce: string }) => {
  const flavor: FlavorType = FLAVORS.includes(sauce)
    ? fireMapping[sauce]
    : fireMapping["Default"];
  const fires = [1, 2, 3, 4, 5];
  const colors: any = {
    green: "#006938",
    orange: "#FF9000",
    red: "#FF0000",
    gray: "#707070",
  };

  return (
    <div className="fireRatingContainer">
      {fires.map((el) => {
        if (el <= flavor.scale) {
          return <Fire fill={colors[flavor.color]} key={flavor.color + el} />;
        }
        return <Fire fill={colors["gray"]} key={flavor.color + el} />;
      })}
    </div>
  );
};
